export default function moneyFormat(money) {
  let newNumber = new Intl.NumberFormat("jp-JP", { style: "currency", minimumFractionDigits: 0, currency: "JPY" }).format(money);
  // newNumber.slice(0,2)
  return newNumber
}
